import { c as _c } from "react/compiler-runtime";
import { CRM_PIPELINE_API } from 'modules/crm/api/crm-pipeline-api';
import { ModalCreatePipeline } from 'modules/crm/components/create-pipeline';
import { CrmPipelineLoco } from 'modules/crm/constants/crm-pipeline-loco';
import { useCrmPipelineList } from 'modules/crm/hooks/use-crm-pipeline-list';
import { useDeletePipeline } from 'modules/crm/hooks/use-delete-pipline-';
import { ModalEditPipeline } from 'modules/crm/pipeline/components/edit-pipeline';
import { PipelineInterface } from 'modules/crm/types/pipeline-interface';
import { getPipelineUrl } from 'modules/crm/utils/get-pipeline-url';
import { NextPage } from 'next';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
const CrmPipelines: NextPage = () => {
  const $ = _c(69);
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const {
    limit,
    setLimit,
    pagination,
    setPagination
  } = usePagination();
  let t0;
  if ($[0] !== limit || $[1] !== pagination) {
    t0 = {
      pagination,
      limit
    };
    $[0] = limit;
    $[1] = pagination;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    crmPipelineList,
    mutate,
    counter
  } = useCrmPipelineList(t0);
  const {
    deletePipeline
  } = useDeletePipeline();
  let t1;
  if ($[3] !== setPagination) {
    t1 = {
      setPagination,
      api: CRM_PIPELINE_API
    };
    $[3] = setPagination;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const updateData = useUpdateData(t1);
  let t2;
  if ($[5] !== crmPipelineList || $[6] !== updateData) {
    t2 = async () => {
      await updateData(false, crmPipelineList);
    };
    $[5] = crmPipelineList;
    $[6] = updateData;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const onUpdateData = t2;
  let t3;
  if ($[8] !== t) {
    t3 = t("global.title");
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = {
      key: "name",
      header: t3,
      widthPercent: 70,
      onRender: _temp
    };
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t) {
    t5 = t("global.created_on");
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== user?.dateFormat || $[15] !== user?.timeFormat || $[16] !== user?.timezone) {
    t6 = pipeline_0 => <span>{dateTimeFormat(pipeline_0.createdAt, {
        timeFormat: user?.timeFormat,
        dateFormat: user?.dateFormat,
        timeZone: user?.timezone
      })}</span>;
    $[14] = user?.dateFormat;
    $[15] = user?.timeFormat;
    $[16] = user?.timezone;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = {
      key: "pipeline.createdAt",
      header: t5,
      widthPercent: 30,
      onRender: t6
    };
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t4 || $[22] !== t7) {
    t8 = [t4, t7];
    $[21] = t4;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const columns = t8;
  let t9;
  if ($[24] !== deletePipeline || $[25] !== onUpdateData) {
    t9 = async pipelineId => {
      await deletePipeline(pipelineId);
      await onUpdateData();
    };
    $[24] = deletePipeline;
    $[25] = onUpdateData;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const onRemovePipeline = t9;
  let t10;
  if ($[27] !== crmPipelineList || $[28] !== mutate || $[29] !== updateData) {
    t10 = async response => {
      await updateData(false, undefined, {
        mutationData: crmPipelineList,
        onMutate: async () => {
          await mutate(data => {
            if (data) {
              return {
                items: data.items.map(item => {
                  if (item.id === response.id) {
                    return response;
                  }
                  return item;
                }),
                hasMore: data.hasMore
              };
            }
          }, false);
        }
      });
    };
    $[27] = crmPipelineList;
    $[28] = mutate;
    $[29] = updateData;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  const mutateData = t10;
  let t11;
  if ($[31] !== t) {
    t11 = t("dashboard.crm_pipeline.title_plural");
    $[31] = t;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== onUpdateData) {
    t12 = <ModalCreatePipeline onUpdateData={onUpdateData} />;
    $[33] = onUpdateData;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t) {
    t13 = t("dashboard.crm_pipeline.title");
    $[35] = t;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== limit || $[38] !== setLimit) {
    t14 = {
      limit,
      setLimit
    };
    $[37] = limit;
    $[38] = setLimit;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== pagination || $[41] !== setPagination) {
    t15 = {
      pagination,
      setPagination
    };
    $[40] = pagination;
    $[41] = setPagination;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = ["remove"];
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t) {
    t17 = t("global.edit");
    $[44] = t;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== mutateData) {
    t18 = (opened, onClose, pipeline_1, key) => <ModalEditPipeline key={key} pipeline={pipeline_1} mutate={mutateData} opened={opened} onClose={onClose} />;
    $[46] = mutateData;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== t17 || $[49] !== t18) {
    t19 = [{
      name: "edit",
      caption: t17,
      onActionRender: t18
    }];
    $[48] = t17;
    $[49] = t18;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== onRemovePipeline) {
    t20 = {
      onChange: pipeline_2 => onRemovePipeline(pipeline_2.id)
    };
    $[51] = onRemovePipeline;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  let t21;
  if ($[53] !== t19 || $[54] !== t20) {
    t21 = {
      custom: t19,
      remove: t20
    };
    $[53] = t19;
    $[54] = t20;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  let t22;
  if ($[56] !== columns || $[57] !== crmPipelineList || $[58] !== t13 || $[59] !== t14 || $[60] !== t15 || $[61] !== t21) {
    t22 = <Table data={crmPipelineList} columns={columns} caption={t13} limiter={t14} paginator={t15} actionsOrder={t16} actions={t21} />;
    $[56] = columns;
    $[57] = crmPipelineList;
    $[58] = t13;
    $[59] = t14;
    $[60] = t15;
    $[61] = t21;
    $[62] = t22;
  } else {
    t22 = $[62];
  }
  let t23;
  if ($[63] !== counter || $[64] !== crmPipelineList || $[65] !== t11 || $[66] !== t12 || $[67] !== t22) {
    t23 = <ListingLayout counter={counter} data={crmPipelineList} title={t11} type="compact" customHeaderElement={t12}>{t22}</ListingLayout>;
    $[63] = counter;
    $[64] = crmPipelineList;
    $[65] = t11;
    $[66] = t12;
    $[67] = t22;
    $[68] = t23;
  } else {
    t23 = $[68];
  }
  return t23;
};
export const getServerSideProps = getBaseServerSideProps(CrmPipelineLoco);
export default CrmPipelines;
function _temp(pipeline) {
  return <LinkWithoutPrefetch rel="noreferrer" className="primary-link w-full" href={getPipelineUrl(pipeline.id)}>{pipeline.name}</LinkWithoutPrefetch>;
}